<div aria-controls="fileupload" aria-disabled="false" class="dds-uploader">
  <strong *ngIf="uploadAreaOptions.heading" class="dds-uploader__title">{{
    uploadAreaOptions.heading
  }}</strong>
  <span
    *ngIf="uploadAreaOptions.description"
    class="dds-uploader__description"
    >{{ uploadAreaOptions.description }}</span
  >
  <div
    role="region"
    class="dds-uploader-drag-area cursor-clickable"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="selectFileBtn?.click()"
  >
    <span
      class="dds-icon dds-icon_lg dds-icon_upload dds-uploader-drag-area__icon"
    ></span>
    <span class="dds-uploader-drag-area__title">{{
      uploadAreaOptions.dragAndDropText
    }}</span>
  </div>

  <div class="dds-btn dds-btn_primary" (click)="selectFileBtn?.click()">
    <div class="dds-btn__content dds-uploader__btn-content">
      <span class="dds-btn__text">{{ uploadAreaOptions.btnLabel }}</span
      ><input
        #selectFileBtn
        type="file"
        class="dds-uploader__field"
        [multiple]="uploadAreaOptions.isMultiple"
        [accept]="uploadAreaOptions.acceptExtensions"
        aria-required="false"
        tabindex="0"
        [disabled]="uploadAreaOptions.disabled"
        (change)="onFileSelect($event)"
      />
    </div>
  </div>
  <div role="list" class="dds-uploader__list"></div>
</div>
